export default "__VITE_ASSET__Cv4$UIRg__"